import useNotyf from '@/hooks/useNotyf'
import { ERROR_MESSAGES } from '@/lib/constants'

export function useShowGenericServerError() {
  const notyf = useNotyf()

  return function () {
    notyf.open({
      type: 'error',
      message: ERROR_MESSAGES.genericServerError,
      duration: 9000,
    })
  }
}
